import { Builder } from '@builder.io/react';
import { BUILDER_HERO_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { BrandPartnerHero } from '../components/hero/BrandPartnerHero.builder';
import { getBackgroundColorInput, getBackgroundGradientInput, getPaddingInputs } from '../utils/builderSharedInputs';
import { backgroundGradientOptions } from '../utils/builderColorOptions';

Builder.registerComponent(BrandPartnerHero, {
    name: BUILDER_HERO_COMPONENTS_NAMES.BrandPartnerHero,
    friendlyName: 'Brand Partner Hero',
    image: 'https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2Fd6d3bc814ffd47b182ec8345cc5438c0',
    inputs: [
        {
            name: 'heroDesktopImage',
            friendlyName: 'Hero Desktop Image',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            required: true,
            defaultValue:
                'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F3b5169d964e74207b55df73e85afec18',
        },
        {
            name: 'heroDesktopImageAlt',
            type: 'string',
            friendlyName: 'Hero Desktop Image Alt',
            defaultValue: 'Hero Desktop Image',
            required: true,
        },
        {
            name: 'heroTabletImage',
            friendlyName: 'Hero Tablet Image',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            required: true,
            defaultValue:
                'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F3b5169d964e74207b55df73e85afec18',
        },
        {
            name: 'heroTabletImageAlt',
            type: 'string',
            friendlyName: 'Hero Tablet Image Alt',
            defaultValue: 'Hero Tablet Image',
            required: true,
        },
        {
            name: 'heroMobileImage',
            friendlyName: 'Hero Mobile Image',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            required: true,
            defaultValue:
                'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F8eebbdc8e8f34d31b5df2c955dda6cd0',
        },
        {
            name: 'heroMobileImageAlt',
            type: 'string',
            friendlyName: 'Hero Mobile Image Alt',
            defaultValue: 'Hero Mobile Image',
            required: true,
        },
        {
            name: 'subHeading',
            type: 'string',
            defaultValue: 'Your exclusive $250 savings awaits — schedule your consultation to get started',
            required: false,
        },
        {
            name: 'subHeadingColor',
            friendlyName: 'Sub Heading Color',
            type: 'string',
            enum: ['milan-text-primary', 'milan-text-white', 'milan-text-navy', 'milan-text-black'],
            defaultValue: 'milan-text-primary',
            required: false,
            helperText: 'Select the color for the heading text on desktop (primary=blue)',
        },

        ...getBackgroundColorInput({
            helperText: 'Select None if a background gradient is selected.',
        }),
        ...getBackgroundGradientInput({
            backgroundGradientName: 'gradient',
            defaultValue: 'None',
            backgroundGradientList: backgroundGradientOptions,
            helperText: 'Select None if a background color is selected.',
        }),
        ...getPaddingInputs({
            desktopTop: 'large',
            desktopBottom: 'large',
            mobileTop: 'small',
            mobileBottom: 'small',
        }),
    ],
});
